import { ID } from "@types";
import { IErrorResponse } from "@api";
import { useState } from "react";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getService, IService } from "../services/services";

export const useService = (serviceId: ID | undefined) => {
  const [apiError, setApiError] = useState<IErrorResponse>();
  const {
    data: service,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<IService>(
    ["service", Number(serviceId)],
    async () => {
      try {
        const response = await getService(serviceId);
        return response.data;
      } catch (error) {
        setApiError(error);
        throw error;
      }
    },
    {
      enabled: !!serviceId && !isNaN(Number(serviceId)),
    }
  );

  return {
    service,
    isLoading,
    isError,
    isSuccess,
    status,
    apiError,
  };
};
